import { Button, Col, Form, Input, notification, Row, Switch } from "antd"

export const ResetPassword = (props) => {
    const [form] = Form.useForm();

    const onFinish = (values) => {
        // console.log(values);
    };
    const resetData = () => {
        form.resetFields()
    };

    return (
        <Form
            name="addPlanPricingForm"
            className="addPlanPricingForm"
            form={form}
            onFinish={onFinish}
        >
            <div className="logoSection">
                <h4 className="mb-0">Reset Password</h4>
            </div>
            <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]} className="mt-3">
                <Col xs={24} md={12} xl={11} xxl={11}>
                    <label className="form-input-label">
                        New Password
                        <span className="asterik"> *</span>
                    </label>
                    <Form.Item
                        name="name"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter New Password!",
                            },
                        ]}
                    >
                        <Input placeholder="Enter New Password" className="mt-2 p-2" />
                    </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={11} xxl={11}>
                    <label className="form-input-label">
                        Current Password
                        <span className="asterik"> *</span>
                    </label>
                    <Form.Item
                        name="active_clients"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Current Password!",
                            },
                        ]}
                    >
                        <Input placeholder="Enter Current Password" className="mt-2 p-2" />
                    </Form.Item>
                </Col>
                <Col span={24} className="text-center">
                    <Button htmlType="submit" className="submit-button b-0 rounded">
                        Save
                    </Button>
                    <Button onClick={() => props.setIsModalVisible(false)} className="reset-button ms-4 b-0 rounded">
                        Close
                    </Button>
                </Col>
            </Row>
        </Form>

    )
}